const CardFilterNormal = ({ title, isClass, children, classMain }) => (
	<div className={`${classMain ? classMain : 'search__type'}`}>
		<p className="search__type--title">{title}</p>
		<div className={isClass}>
			{children}
		</div>
	</div>
)

export default CardFilterNormal